import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import bookmark from "views/know-us-more/img/bookmark.svg";
import TrendingJobs1 from "views/know-us-more/img/portfolio/t1.png";
// install Swiper modules
import pin from "views/know-us-more/img/pin.svg";
import { connect } from "react-redux";
// import Swiper core and required modules
import { Link } from "react-router-dom";
import moment from "moment";
import {getRelatedPortfoliosByIDAction} from "store/Home"
SwiperCore.use([Pagination, Navigation]);

class KnowUsMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      arr: [],
      ptag: "",
      currentPortfolio: [],
      currentPageNo: 1,
      RelatedPortfolios:[]
    };
  }
  componentDidUpdate = async (prevProps) => {
    // console.log(prevProps)
    if (this.props.id !== prevProps.id) {
      let previewJobs=this.props.previewjob;
    // console.log(previewJobs)
    let realtedPortfolios = await this.props.getRelatedPortfolios({
      RelatedPortfolioIDs: previewJobs.Data[0].p_relatedPortfolios
    })
    if(realtedPortfolios.Data){
    // console.log(realtedPortfolios.Data)
      this.setState({RelatedPortfolios:realtedPortfolios.Data})
    }
    else{
      this.setState({RelatedPortfolios:[]})
    }
    }}
  async componentDidMount(){
    try {
      
    let previewJobs=this.props.previewjob;
    if(previewJobs.Data.length>0){
    let realtedPortfolios = await this.props.getRelatedPortfolios({
      RelatedPortfolioIDs: previewJobs.Data[0].p_relatedPortfolios
    })
    if(realtedPortfolios.Data){
    // console.log(realtedPortfolios.Data)
      this.setState({RelatedPortfolios:realtedPortfolios.Data})
    }
    else{
      this.setState({RelatedPortfolios:[]})
    }
  }
} catch (error) {
      console.log(error)
}
  }
  componentWillUnmount(){
    this.setState({RelatedPortfolios:[]})
  }
  add_default_src(ev){
    ev.target.src = TrendingJobs1
  }
  render() {

    return (
      <>
        <div className="flex justify-between items-center mt-16 mb-8">
          <h2 className="fsize28 sm-fsize16 font-bold uppercase">
            check out other portfolios
          </h2>
          <div className="flex ">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2 disabled"
            />
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i"
            />
          </div>
        </div>
        <Swiper
          breakpoints={{
            1366: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            420: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            375: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          }}
          spaceBetween={30}
          slidesPerGroup={4}
          loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          className="mySwiper swiperpagination-dot"
        >
          
              {this.state.RelatedPortfolios.map((datajobs, index) => {
                return (
                  <SwiperSlide className="shadow-lg rounded-b-lg mb-4 showcard">
                    <div className="img__wrap w-full">
                      <div className="relative">
                        <img
                        onError={this.add_default_src}
                          src={
                            process.env.REACT_APP_IMAGE_BASE_MG +
                            "/" +
                            datajobs.p_path
                          }
                          className="w-full rounded-t-12px cust-h210px"
                          alt="banner-img "
                        />{" "}
                        <div className="lg:p-4 md:p-4 lg:p-4  md:p-4 p-3">
                          <p className="text-black  sm-fsize12 sm-font-semibold line-clamp-1	font-medium fsize18  ">
                            {datajobs.p_title}
                          </p>
                        </div>
                      </div>

                      <div className="img__description_layer">
                        <h1 className="img__description trend-hover-h truncate">
                          Portfolio
                        </h1>{" "}
                        <div className="absolute bookmark-parent text-white rounded-full">
                          <img src={bookmark} className="bookmark-t-c" />
                        </div>
                        <div className="lg:p-4  md:p-4 p-2">
                          <p className="text-black font-bold  sm-fsize12 line-clamp-1 fsize18">
                            {datajobs.p_title}
                          </p>
                        </div>
                        {/* <p className="text-muted-1 ">
                        Required Experience:{" "}
                        <span className="text-black ">1-3 years</span>
                      </p>
                      <p className="text-muted-1 ">
                        Education: <span className="text-black ">CA</span>
                      </p> */}
                        <div className="flex justify-around mt-4">
                          <div className="flex items-center">
                            <img src={pin} className="pn-icon-w" />

                            <p className="text-muted-1 ml-2">India</p>
                          </div>

                          <p className="text-muted-1 ">
                            {" "}
                            {moment(datajobs.p_createdDate).fromNow()}
                          </p>
                        </div>
                        <div className="flex justify-center">
                          <Link
                            to={{
                              pathname:
                                process.env.PUBLIC_URL +
                                "/Career/know-us-more/" +
                                datajobs.p_id,
                              state: datajobs.p_value,
                            }}
                            class="cust-trendapply-btn flex"
                          >
                            {datajobs.p_button_Text !== null
                              ? datajobs.p_button_Text
                              : "VIEW"}
                          </Link>
                          {/* <button className="cust-trendapply-btn flex">VIEW</button> */}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
        </Swiper>
        {/* <div className="flex justify-center mt-12">
            <button className="cust-viewall-btn flex">VIEW ALL</button>
          </div> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    previewjob: state.SinglePortfolio.home.PREVIEWJOB,
    RelatedPortfolios :state.Home.home.GET_RELATED_PORTFOLIOS
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      getRelatedPortfolios :async (payload) => await dispatch(getRelatedPortfoliosByIDAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(KnowUsMore);
